import Sorry from "../../../assets/images/Sorry.webp";
import SorryWtRobot from "../../../assets/images/SorryWtRobot.png";

function ReservationError({ isInvalidEmail }) {
  return (
    <div className="leap-text-white leap-w-full leap-text-center leap-mb-5 leap-px-2 leap-mx-auto">
      {isInvalidEmail ? (
        <h1 className="leap-text-3xl leap-font-bold">Invalid Email Address</h1>
      ) : (
        <>
          <h1 className="leap-text-3xl leap-font-bold">
            This Email Is Not Eligible To Receive A Tour
          </h1>
          <p className="leap-text-lg leap-mt-1">
            Please Use Your Registered Email
          </p>
        </>
      )}
    </div>
  );
}

export default ReservationError;
